import useStyles from "../../inventory/styles";
import { Grid } from "@mui/material";
import { useState, useEffect } from "react";
import VerticalLine from "../../../assets/images/verticallines.svg";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";
import { useParams, useNavigate } from "react-router-dom";
import useWindowSize from "../../../hooks/useWindow";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Badge from "../../../components/Badge";
import { accessDeleteInventoryItem } from "../../../data/roles";
import { useUserState } from "../../../context/UserContext";

const INVENTORY_ENDPOINT = "/api/v1/hostel-management/hostel-inventory";
// const INVENTORY_CATEGORY_ENDPOINT = "/api/v1/inventory/category";
// const EMPLOYEES_ENDPOINT = "/api/v1/employees";

const ViewInventory = ({ item_id }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isGetting, setIsGetting] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [auditModal, setAuditModal] = useState(false);
  const { id } = useParams();
  const width = useWindowSize();
  const { userRole } = useUserState();
  const AuditMobile = width < 900;
  const [viewInventoryForm, setViewInventoryForm] = useState({
    name: "",
    description: "",
    category: "",
    employee_in_charge: "",
    quantity: "",
    condition: "",
    images: [],
    status: ""
  });

  const handleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleAuditModal = () => {
    setAuditModal(!auditModal);
  };

  const handleCloseAuditModal = () => {
    setAuditModal(false);
  };

  const handleDeleteInventory = () => {
    setIsDeleting(true);
    httprequest.delete(`${INVENTORY_ENDPOINT}/${item_id}?hostel_id=${id}`).then(() => {
      setIsDeleting(false);
      handleCloseDeleteModal();
      navigate(`/hostel/inventory/${id}`);
      toast.success("Inventory Deleted");
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const getCurentInventory = () => {
    setIsGetting(true);
    httprequest.get(`${INVENTORY_ENDPOINT}/${item_id}/inventory?hostel_id=${id}`).then((res) => {
      setViewInventoryForm({ ...viewInventoryForm,
        name: res?.data?.data?.name,
        description: res?.data?.data?.description,
        category: res?.data?.data?.category?.category,
        employee_in_charge: `${res?.data?.data?.employee_in_charge?.first_name} ${res?.data?.data?.employee_in_charge?.last_name}`,
        quantity: res?.data?.data?.quantity?.toString(),
        status: res?.data?.data?.status,
        images: res?.data?.data?.images,
        condition: res?.data?.data?.condition });
      setSearchResult(res?.data?.data);
      setIsGetting(false);
    }).catch((err) => {
      setIsGetting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  useEffect(() => {
    // getAllInventoryCategory();
    // getAllEmployees();
    getCurentInventory();
  }, []);

  const { name, description, category, images, employee_in_charge, quantity, condition, status } = viewInventoryForm;

  return (
    <div>
      <Grid
        container
        spacing={4}
        sx={{
          "@media (max-width: 1000px)": {
            flexWrap: "wrap-reverse"
          }
        }}
      >
        <Grid item lg={8} md={8} sm={12} xs={12}>
          <div className={`${classes.paddingcont}`}>
            <div className="left-container border_only">
              <div>
                <div className={`${classes.previewsubheader} text-align-left`}>
                  <div className="flex gap-10 justify-items-space align-items-center">
                    <h5>Inventory Details</h5>
                    <div className="table-action-container">
                      {AuditMobile ? (
                        <button
                          onClick={() => handleAuditModal()}
                          className="table-action-icon"
                        >
                          <Icon icon="iconamoon:question-mark-circle" />
                        </button>
                      ) : null}
                      {/* {accessUpdateInventoryItem(userRole) && (
                        <Link onClick={() => {
                          setSelectedItemId(item_id);
                          setViewMode("edit");
                        }} className="table-action-icon"
                        >
                          <Icon className="table-action-icon" icon="heroicons:pencil-square-solid" />
                        </Link>
                      )} */}
                      {accessDeleteInventoryItem(userRole) && (
                        <button
                          onClick={handleDeleteModal}
                          className="table-action-icon delete-icon"
                        >
                          <Icon icon="mingcute:delete-2-line" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {isGetting ? <PageLoader /> : (
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={6} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Product Name</p>
                        <h4>{name || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Status</p>
                        <Badge status={status} />
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Condition</p>
                        <h4>{condition || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Teacher in Charge</p>
                        <h4>{employee_in_charge || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Category</p>
                        <h4>{category || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Quantity</p>
                        <h4>{quantity || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Description</p>
                        <h4>{description || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  {images?.length > 0 && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className={classes.fordesc}><p>Images</p></div>
                      <Grid container spacing={2}>
                        {images.map((option, i) => (
                          <Grid item lg={2} md={2} sm={4} xs={3} key={i}>
                            <img
                              src={option?.file_url}
                              alt={`Option ${i + 1}`}
                              style={{ width: "100%", height: "auto", borderRadius: "8px" }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              )}

            </div>
          </div>
        </Grid>
        {!AuditMobile && (
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className={`${classes.paddingcont}`}>
              <div className={`${classes.rightcont} border_only`}>
                <div className={`${classes.notedetails}`}>
                  {searchResult?.audit_trail?.map((update, i) => {
                    return (
                      <div key={i}>
                        <div
                          className="flex gap-10 align-items-center margin-bottom-10"
                        >
                          <Icon
                            icon="lets-icons:check-fill"
                            width="32"
                            height="32"
                            style={{ color: "#3FAC64" }}
                          />
                          <div>
                            <h5>Updated at</h5>
                            <p>{update?.updated_at?.substring(0, 10)} | {update?.updated_at?.substring(11, 16)}</p>
                            <p>{update?.updated_by?.last_name} {update?.updated_by?.first_name}</p>
                          </div>
                        </div>
                        <div className={classes.verticalline}>
                          <img src={VerticalLine} alt="" />
                        </div>
                      </div>
                    );
                  })}
                  {searchResult && (
                    <div className="flex gap-10 align-items-center margin-bottom-10">
                      <Icon
                        icon="mdi:cloud-clock-outline"
                        width="25"
                        height="25"
                        style={{
                          color: "#0e9504",
                          border: "1px solid #0e9504",
                          borderRadius: "20px",
                          padding: "5px",
                          marginLeft: "5px"
                        }}
                      />
                      <div>
                        <h5>Created at</h5>
                        <p>{searchResult?.created_at?.substring(0, 10)} | {searchResult?.created_at?.substring(11, 16)}</p>
                        <p>{searchResult?.created_by_user?.last_name} {searchResult?.created_by_user?.first_name}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Grid>
        )}
        {/* <ToastContainer /> */}
      </Grid>
      {/* Delete Modal */}
      <Modal
        title="Delete Inventory"
        subtitle={
          <div>Are you sure you want to delete? If deleted, employee will no longer have access to this Inventory.
          </div>}
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Delete Inventory" buttonSize="full" color="btndefault" onClick={handleDeleteInventory} isLoading={isDeleting} />
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
      {/* Modal For Audit inventory category */}
      <Modal
        title={`Audit Log of ${searchResult?.category?.category || "--/--"} Category`}
        subtitle="Audit log details of your current inventory"
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <div className={`${classes.paddingcont}`}>
                  <div className={`${classes.rightcont}`}>
                    <div className={`${classes.notedetails}`}>
                      {searchResult?.audit_trail?.map((update, i) => {
                        return (
                          <div key={i}>
                            <div
                              className="flex gap-10 align-items-center margin-bottom-10"
                            >
                              <Icon
                                icon="lets-icons:check-fill"
                                width="32"
                                height="32"
                                style={{ color: "#3FAC64" }}
                              />
                              <div>
                                <h5>Updated at</h5>
                                <p>{update?.updated_at?.substring(0, 10)} | {update?.updated_at?.substring(11, 16)}</p>
                                <p>{update?.updated_by?.last_name} {update?.updated_by?.first_name}</p>
                              </div>
                            </div>
                            <div className={classes.verticalline}>
                              <img src={VerticalLine} alt="" />
                            </div>
                          </div>
                        );
                      })}
                      {searchResult && (
                        <div className="flex gap-10 align-items-center margin-bottom-10">
                          <Icon
                            icon="mdi:cloud-clock-outline"
                            width="25"
                            height="25"
                            style={{
                              color: "#0e9504",
                              border: "1px solid #0e9504",
                              borderRadius: "20px",
                              padding: "5px",
                              marginLeft: "5px"
                            }}
                          />
                          <div>
                            <h5>Created at</h5>
                            <p>{searchResult?.created_at?.substring(0, 10)} | {searchResult?.created_at?.substring(11, 16)}</p>
                            <p>{searchResult?.created_by_user?.last_name} {searchResult?.created_by_user?.first_name}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
          </>
        }
        isopen={auditModal}
        closeModal={handleCloseAuditModal}
      />
    </div>
  );
};

export default ViewInventory;
